export const onRouteUpdate = (_) => {
  if (
    process.env.NODE_ENV === `production`
  ) {
    setTimeout(() => {
      if (typeof acalltracker !== 'undefined') {
        acalltracker.dynamicPageload();
      }
    }, 50)
  }
}

import { createRoot } from 'react-dom/client';

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = createRoot(container)
    root.render(element)
  }
}
